import { Button, IconButton, Loader, PopoverMenu, Text } from '@wix/design-system'
import { ChevronLeft, Hidden, HiddenSmall, MoreSmall, Visible } from '@wix/wix-ui-icons-common'
import React, { useEffect } from 'react'
import { useSettingsContext } from '../context/SettingsContext'
import { Review } from '../models/shared/Review';
import { useFirestore } from 'reactfire';
import { collection, limit, onSnapshot, orderBy, query } from 'firebase/firestore';
import { Collections } from '../utils/shared/constants';
import { fromFirebaseDocs } from '../utils/shared/firebase';

const MAX_REVIEWS = 100;

export default function ManageReviewsDisplay() {
    const { settings, processing, updateSettings, navigate } = useSettingsContext();
    const [reviews, setReviews] = React.useState<Review[]>([]);
    const db = useFirestore();


    useEffect(() => {
        if (!settings?.placeId) {
            return;
        }
        const _col = collection(db, Collections.places, settings.placeId, Collections.reviews);
        const q = query(_col, orderBy('time', 'desc'), limit(MAX_REVIEWS));
        return onSnapshot(q, snapshot => {
            const newReviews = fromFirebaseDocs<Review>(snapshot.docs);

            setReviews(newReviews);
        })
    }, [db, settings?.placeId]);

    const handleToggleHide = (reviewId: string) => {
        const newHideReviews = settings?.hiddenReviews || [];
        if (newHideReviews.includes(reviewId)) {
            updateSettings({ hiddenReviews: newHideReviews.filter(id => id !== reviewId) });
        } else {
            updateSettings({ hiddenReviews: [...newHideReviews, reviewId] });
        }
    }

    return (
        <div className='settings'>
            <div className='section'>
                <Button priority="secondary" size="tiny" prefixIcon={<ChevronLeft />} onClick={() => navigate('home')}>
                    Back
                </Button>

                {!reviews.length && <div className='center gap-2'>
                    <Loader size='tiny' />
                    <Text size='tiny' >Loading Reviews</Text>
                </div>}
            </div>

            <div className='section d-flex flex-column gap-3'>
                {reviews.map(review => {
                    const isHidden = settings?.hiddenReviews?.includes(review.id || '');

                    const renderPrefixIcon = () => {
                        if (processing) {
                            return <Loader size='tiny' />;
                        }

                        if (isHidden) {
                            return <IconButton disabled size='small' priority='secondary'><HiddenSmall /></IconButton>;
                        }

                        return null;
                    }

                    return <div className='d-flex justify-content-between align-items-center' key={review.id}>
                        <div className='d-flex flex-column gap-1'
                            style={{ opacity: isHidden ? 0.5 : 1 }}
                        >
                            <Text size="small" weight="bold">
                                {review.author_name}
                            </Text>
                            <Text size="small" weight="thin">
                                {review.time ? new Date(review.time).toLocaleDateString() : 'No date'}
                            </Text>
                        </div>
                        <div className='d-flex align-items-center gap-2'>
                            {renderPrefixIcon()}
                            <PopoverMenu
                                textSize="small"
                                triggerElement={
                                    <IconButton size="small" priority="secondary">
                                        <MoreSmall />
                                    </IconButton>
                                }
                                placement='left'
                            >
                                <PopoverMenu.MenuItem prefixIcon={isHidden ? <Visible /> : <Hidden />} text={isHidden ? 'Unhide' : 'Hide'}
                                    onClick={() => handleToggleHide(review.id || '')}
                                />
                            </PopoverMenu>
                        </div>
                    </div>
                })}
            </div>
        </div>
    )
}
